import { api } from './client';

export type RuleAction = 'ALLOW' | 'DENY' | 'REJECT' | 'LIMIT';
export type RuleDirection = 'IN' | 'OUT';

export interface UfwRule {
  number: number;
  action: RuleAction;
  direction: RuleDirection;
  to: { port?: number; port_range?: [number, number]; protocol?: 'tcp' | 'udp' };
  from: { type: 'anywhere' | 'ip' | 'cidr'; value?: string };
  ipv6: boolean;
  comment: string;
  managed: boolean;
  protected: boolean;
}

export interface FirewallStatus {
  active: boolean;
  default_incoming: string;
  default_outgoing: string;
  rules: UfwRule[];
  docker_env?: boolean;
}

export interface AddRulePayload {
  action: 'allow' | 'deny' | 'reject' | 'limit';
  port: string;
  proto: 'tcp' | 'udp' | 'any';
  from?: string;
  comment?: string;
}

export const fetchFirewallStatus = (): Promise<FirewallStatus> =>
  api.get<FirewallStatus>('/firewall/status').then((r) => r.data);

export const fetchMyIp = (): Promise<{ ip: string }> =>
  api.get<{ ip: string }>('/firewall/my-ip').then((r) => r.data);

export const addRule = (payload: AddRulePayload): Promise<void> =>
  api.post('/firewall/rules', payload).then(() => undefined);

export const deleteRule = (num: number): Promise<void> =>
  api.delete(`/firewall/rules/${num}`).then(() => undefined);

export const enableFirewall = (): Promise<void> =>
  api.post('/firewall/enable').then(() => undefined);

export const disableFirewall = (): Promise<void> =>
  api.post('/firewall/disable').then(() => undefined);
